import { Canvas } from 'glsl-canvas-js';

class LambdaPixelShaders
{
	static CurrentShaders = [];
	static PixelShaderHeader = `#version 300 es

precision mediump float;

out vec4 fragColor;

uniform vec2 u_resolution;
uniform vec2 u_mouse;
uniform float u_time;

#define iResolution u_resolution
#define iTime u_time
#define iMouse u_mouse`;

	static PixelShaderFooter = `
void main () {
    mainImage(fragColor, gl_FragCoord.xy);
}`;

	static init()
	{
		//Destroy any current shaders since the page has changed
		this.CurrentShaders.forEach((shader) => {
			shader.destroy();
		});

		this.CurrentShaders = [];

		this.waitForShaderScroll();

	}

	static waitForShaderScroll()
	{
		let observer = new IntersectionObserver((entries, observer) => {

			entries.forEach(entry => {

				if(entry.isIntersecting)
				{
					console.log("Creating shader", entry.target.id);
					this.createShaderInstance(entry.target);
				}
				else
				{
					if(this.CurrentShaders[entry.target.id])
					{
						this.CurrentShaders[entry.target.id].destroy();
						delete this.CurrentShaders[entry.target.id];
						console.log("Destroyed shader", entry.target.id);
					}
				}

			});

		}, {
			root: null,
			rootMargin: '0px',
			threshold: 0.5
		});

		document.querySelectorAll('.lambda-shader').forEach((element) => {
			observer.observe(element);
		});
	}

	static async createShaderInstance(elem) {

		let materialPath = elem.getAttribute("data-material-path");

		console.log("Fetching material data: ", materialPath);

		let materialData = await fetch(materialPath).then(response => response.json());

		if(materialData.Shader === undefined) {
			console.error("No shader specified in material data");
			return;
		}

		let shaderUrl = this.replaceFileName(materialPath, materialData.Shader);

		let shaderCode = await fetch(shaderUrl).then(response => response.text());

		shaderCode = this.PixelShaderHeader + "\n\n" + shaderCode + "\n" + this.PixelShaderFooter;

		this.CurrentShaders[elem.id] = new Canvas(elem, {
			vertexString: null,
			fragmentString: shaderCode,
			onError: (err) => { console.error(err); },
		});

	}

	static replaceFileName(url, newFileName)
	{
		const parsedUrl = new URL(url);

		const parts = parsedUrl.pathname.split('/');
		parts[parts.length - 1] = newFileName;

		parsedUrl.pathname = parts.join('/');

		return parsedUrl.toString();
	}

}

export default LambdaPixelShaders;
